module.exports = __webpack_public_path__ + "assets/img/cdz.45eb421c.png";